export default {
  type: "",
  data: {},
  error: ""
};
